<template>
  <div :class="['text-cutter-wrapper', expanded ? 'expanded' : 'no-expand', wrapperClass]">
    <div class="text mb-3" :class="{ 'expanded': expanded }" :style="lineClampStyle" v-html="text.replaceAll('\n', '<br/>')"></div>
    <div v-if="shouldShowButton" class="button-wrapper text-center justify-center flex items-center">
      <button class="read-more-btn flex" @click="toggleExpanded">
        <i class="icon icon-bor-arrow-down transform mt-1" :class="[{'rotate-180' : expanded}]"></i>
        <span class="btn-text">{{ expanded ? '折りたたむ' : 'もっと見る' }}</span>
      </button>
    </div>
    </div>
</template>
<script>
export default {
  name: 'TextLineCutter',
  props: {
    isExpanded: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
      required: true
    },
    lines: {
      type: Number,
      required: true
    },
    wrapperClass: {
        type: String,
        default: ""
    }
  },
  data() {
    return {
      expanded: this.isExpanded,
    };
  },
  computed: {
    shouldShowButton() {
      return this.text.length > this.lines * 20;
    },
    lineClampStyle() {
      if (this.expanded) {
        return {
          '-webkit-line-clamp': 'unset',
          '-webkit-box-orient': 'unset',
          overflow: 'visible',
          display: 'block',
        };
      } else {
        return {
          '-webkit-line-clamp': this.lines,
          '-webkit-box-orient': 'vertical',
          overflow: 'hidden',
          'text-overflow': 'ellipsis',
          display: '-webkit-box',
        };
      }
    },
  },
  methods: {
    toggleExpanded() {
      this.expanded = !this.expanded;
    },
  },
  watch: {
    expanded(newVal) {
      this.$emit('update:isExpanded', newVal);
    },
  },
};
</script>

<style lang="scss" scoped>
.expanded {
  -webkit-line-clamp: unset;
  -webkit-box-orient: unset;
  overflow: visible;
  display: block;
}

.read-more-button {
  margin-top: 10px;
}
@import "./styles.scss";
</style>